const breakpointXxs = "0px";
const breakpointXs = "320px";
const breakpointSm = "480px";
const breakpointMd = "768px";
const breakpointLg = "1024px";
const breakpointXl = "1280px";
const breakpointXxl = "1440px";
const colorBackgroundPrimary = "#FFFFFF";
const colorBackgroundSecondary = "#F8F9FC";
const colorBackgroundAccent = "#154199";
const colorBackgroundAccentLight = "#EFF5FF";
const colorBackgroundRed = "#FFF5F8";
const colorBackgroundOrange = "#FFF4F0";
const colorBackgroundYellow = "#FEF8EC";
const colorBackgroundGreen = "#ECF9F4";
const colorBackgroundBlue = "#EFF5FF";
const colorBackgroundSky = "#E8F8FC";
const colorBackgroundPurple = "#F7F5FF";
const colorBackgroundInformational = "#EFF2F8";
const colorBackgroundPositive = "#ECF9F4";
const colorBackgroundWarning = "#FEF8EC";
const colorBackgroundNegative = "#FFF5F8";
const colorBackgroundStateDisabled = "#EFF2F8";
const colorBackgroundStateAccentHover = "#142E57";
const colorBackgroundInversePrimary = "#27313E";
const colorContentPrimary = "#1D252F";
const colorContentSecondary = "#5C708A";
const colorContentAccent = "#154199";
const colorContentInformational = "#42546B";
const colorContentPositive = "#048155";
const colorContentWarning = "#754515";
const colorContentNegative = "#CF264E";
const colorContentStateDisabled = "#C0CBD8";
const colorContentStatePrimaryHover = "#5C708A";
const colorContentStateAccentHover = "#142E57";
const colorContentInversePrimary = "#F8F9FC";
const colorBorderPrimary = "#C0CBD8";
const colorBorderAccent = "#154199";
const colorBorderOpaque = "#E7ECF3";
const colorBorderSelected = "#3300FF";
const colorBorderNegative = "#CF264E";
const colorBorderStateAccentHover = "#142E57";
const colorBorderStatePrimaryHover = "#5C708A";
const colorBorderStateDisabled = "#C0CBD8";
const colorNeutral0 = "#FFFFFF";
const colorNeutral25 = "#F8F9FC";
const colorNeutral50 = "#EFF2F8";
const colorNeutral75 = "#E7ECF3";
const colorNeutral150 = "#C0CBD8";
const colorNeutral300 = "#5C708A";
const colorNeutral500 = "#42546B";
const colorNeutral600 = "#39485B";
const colorNeutral700 = "#2F3B4B";
const colorNeutral800 = "#27313E";
const colorNeutral900 = "#1D252F";
const colorNeutral950 = "#171D26";
const colorNeutral975 = "#14191F";
const colorBlue25 = "#F5F9FF";
const colorBlue50 = "#EFF5FF";
const colorBlue100 = "#D2E2FE";
const colorBlue200 = "#94BBFE";
const colorBlue300 = "#3B6AF7";
const colorBlue400 = "#2C47F6";
const colorBlue500 = "#3300FF";
const colorBlue600 = "#154199";
const colorBlue800 = "#142E57";
const colorSky25 = "#F7FCFD";
const colorSky50 = "#E8F8FC";
const colorSky100 = "#CCF1F9";
const colorSky200 = "#6DCFE9";
const colorSky300 = "#19B1E2";
const colorSky400 = "#0079A6";
const colorSky600 = "#005080";
const colorSky800 = "#0F3552";
const colorGreen25 = "#F8FCFA";
const colorGreen50 = "#ECF9F4";
const colorGreen100 = "#CFF2E5";
const colorGreen200 = "#75D1AF";
const colorGreen300 = "#33B083";
const colorGreen400 = "#048155";
const colorGreen600 = "#03593B";
const colorGreen800 = "#0E392A";
const colorYellow25 = "#FDFBF7";
const colorYellow50 = "#FEF8EC";
const colorYellow100 = "#FDE8BE";
const colorYellow200 = "#FBCB5B";
const colorYellow300 = "#E39B0D";
const colorYellow400 = "#AA6313";
const colorYellow600 = "#754515";
const colorYellow800 = "#41260B";
const colorOrange25 = "#FFFBFA";
const colorOrange50 = "#FFF4F0";
const colorOrange100 = "#FEDDD2";
const colorOrange200 = "#FCA588";
const colorOrange300 = "#E3744F";
const colorOrange400 = "#C2471E";
const colorOrange600 = "#803319";
const colorOrange800 = "#471E10";
const colorRed25 = "#FEFBFC";
const colorRed50 = "#FFF5F8";
const colorRed100 = "#FEDDE6";
const colorRed200 = "#FB98B2";
const colorRed300 = "#E85E80";
const colorRed400 = "#CF264E";
const colorRed500 = "#BA143A";
const colorRed600 = "#871D35";
const colorRed800 = "#501120";
const colorPurple25 = "#FBFBFE";
const colorPurple50 = "#F7F5FF";
const colorPurple100 = "#E8E2FE";
const colorPurple200 = "#B5A2FB";
const colorPurple300 = "#8A6AE2";
const colorPurple400 = "#5F32C8";
const colorPurple600 = "#4A3082";
const colorPurple800 = "#30224F";
const colorGrassGreen25 = "#F8FCF8";
const colorGrassGreen50 = "#ECF9EB";
const colorGrassGreen100 = "#D0F2CF";
const colorGrassGreen200 = "#7ECB7C";
const colorGrassGreen300 = "#3FA83B";
const colorGrassGreen400 = "#1F781C";
const colorGrassGreen600 = "#1E541C";
const colorGrassGreen800 = "#143913";
export {
  breakpointLg,
  breakpointMd,
  breakpointSm,
  breakpointXl,
  breakpointXs,
  breakpointXxl,
  breakpointXxs,
  colorBackgroundAccent,
  colorBackgroundAccentLight,
  colorBackgroundBlue,
  colorBackgroundGreen,
  colorBackgroundInformational,
  colorBackgroundInversePrimary,
  colorBackgroundNegative,
  colorBackgroundOrange,
  colorBackgroundPositive,
  colorBackgroundPrimary,
  colorBackgroundPurple,
  colorBackgroundRed,
  colorBackgroundSecondary,
  colorBackgroundSky,
  colorBackgroundStateAccentHover,
  colorBackgroundStateDisabled,
  colorBackgroundWarning,
  colorBackgroundYellow,
  colorBlue100,
  colorBlue200,
  colorBlue25,
  colorBlue300,
  colorBlue400,
  colorBlue50,
  colorBlue500,
  colorBlue600,
  colorBlue800,
  colorBorderAccent,
  colorBorderNegative,
  colorBorderOpaque,
  colorBorderPrimary,
  colorBorderSelected,
  colorBorderStateAccentHover,
  colorBorderStateDisabled,
  colorBorderStatePrimaryHover,
  colorContentAccent,
  colorContentInformational,
  colorContentInversePrimary,
  colorContentNegative,
  colorContentPositive,
  colorContentPrimary,
  colorContentSecondary,
  colorContentStateAccentHover,
  colorContentStateDisabled,
  colorContentStatePrimaryHover,
  colorContentWarning,
  colorGrassGreen100,
  colorGrassGreen200,
  colorGrassGreen25,
  colorGrassGreen300,
  colorGrassGreen400,
  colorGrassGreen50,
  colorGrassGreen600,
  colorGrassGreen800,
  colorGreen100,
  colorGreen200,
  colorGreen25,
  colorGreen300,
  colorGreen400,
  colorGreen50,
  colorGreen600,
  colorGreen800,
  colorNeutral0,
  colorNeutral150,
  colorNeutral25,
  colorNeutral300,
  colorNeutral50,
  colorNeutral500,
  colorNeutral600,
  colorNeutral700,
  colorNeutral75,
  colorNeutral800,
  colorNeutral900,
  colorNeutral950,
  colorNeutral975,
  colorOrange100,
  colorOrange200,
  colorOrange25,
  colorOrange300,
  colorOrange400,
  colorOrange50,
  colorOrange600,
  colorOrange800,
  colorPurple100,
  colorPurple200,
  colorPurple25,
  colorPurple300,
  colorPurple400,
  colorPurple50,
  colorPurple600,
  colorPurple800,
  colorRed100,
  colorRed200,
  colorRed25,
  colorRed300,
  colorRed400,
  colorRed50,
  colorRed500,
  colorRed600,
  colorRed800,
  colorSky100,
  colorSky200,
  colorSky25,
  colorSky300,
  colorSky400,
  colorSky50,
  colorSky600,
  colorSky800,
  colorYellow100,
  colorYellow200,
  colorYellow25,
  colorYellow300,
  colorYellow400,
  colorYellow50,
  colorYellow600,
  colorYellow800
};
//# sourceMappingURL=tokens.js.map
